// extracted by mini-css-extract-plugin
export var content = "CreditModal_content__v8SKh";
export var declineButton = "CreditModal_declineButton__5Twqy";
export var disclaimer = "CreditModal_disclaimer__mJI4X";
export var md = "768px";
export var modal = "CreditModal_modal__z3LIw";
export var shared = "'../../shared.module.css'";